<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container login_modal">

                    <header class="modal-header" id="modalTitle">
                        <slot name="header">{{$t('Re-Authentication')}}</slot>
                    </header>

                    <div class="modal-body" id="modalDescription">
                        <slot name="body">
                            <p style="text-align:center; color: #8808089e">{{$t('This operation is sensitive and requires recent authentication. Log in again before retrying this request.')}}</p>
                            <div class="loading" id="modalLoader" v-bind:style="[showModalLoader ? {'display':'block'} : {'display':'none'}]"></div>

                            <section class="modal-inner">
                                <div class="content-wrap">
                                    <div class="re_login">
                                        <div class="warning" id="warning" v-if="errors.length">
                                            <ul>
                                                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                                            </ul>
                                        </div>

                                        <form id="signin" @submit.prevent="login" v-if="tokenData.signInProvider == 'password'">
                                            <input
                                                v-model="email"
                                                v-on:blur="instantValidator($event, 'email')"
                                                name="email"
                                                :placeholder="this.$t('メールアドレス')"
                                                id="email"
                                                autocomplete="email"
                                                value
                                                type="text"
                                                spellcheck="false"
                                            >
                                            <p class="caution" id="email-c">{{emailError}}</p>
                                            <input
                                                v-model="password"
                                                :type="password_type"
                                                v-on:blur="instantValidator($event, 'password')"
                                                :placeholder="this.$t('パスワード')"
                                                id="u_auth_val"
                                                autocomplete="new-password"
                                            >
                                            <span class="show-hide-password" v-on:click="showHidePassword"><i :class="pass_type_icon"></i></span>
                                            <p class="caution" id="password-c">{{passError}}</p>

                                            <button type="submit">{{$t('ログイン')}}</button>
                                        </form>

                                        <div class="sns_login" v-else>
                                            <a class="facebook" v-on:click="facebook_signin" id="fb-sign-in" v-if="tokenData.signInProvider == 'facebook.com'">
                                                <i class="icon-facebook"></i>{{$t('Sign in with Facebook')}}
                                            </a>
                                            <a class="googleplus" v-on:click="google_signin" id="google-sign-in" v-if="tokenData.signInProvider == 'google.com'">
                                                <i class="icon-google"></i>{{$t('Sign in with Google')}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </slot> <!-- End of Modal Body-->
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="btn-green" @click="close" aria-label="Close modal">{{$t('Close')}}</button>
                        </slot>
                    </div>

                </div> <!-- End of Modal Container -->
            </div>
        </div>
    </transition>
</template>

<script>
import UserUtil from "@/utils/UserUtils"
import * as firebase from "firebase/app"
import { sendPasswordReset } from '@/auth/user-meta' 
import { mapState, mapGetters, mapMutations } from "vuex"

const loader = document.getElementById("modalLoader")


export default {
    name: 'modal',
    data: () => ({
        email: null,
        password: null,
        errors: [],
        emailError: "",
        passError: "",
        pass_type_icon: 'icon-eye-slash',
        password_type: 'password',
        showModalLoader: false,
    }),

    computed: {
        ...mapState(["clips", "user"]),
        ...mapGetters({
            languageName: "languageName",
            tokenData: "tokenData"
        }),
    },
    methods: {
        close() {
            this.$emit("close");
        },
        showHidePassword() {
			if(this.password_type === 'password') {
				this.password_type = 'text'
				this.pass_type_icon = 'icon-eye'
			} else {
				this.password_type = 'password'
				this.pass_type_icon = 'icon-eye-slash'
			}            
        },

        toastTopEnd(type, title, text) {
            this.$swal({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 6000,
                type, title, text
            });
        },

        /**
         * Cognito User Pool Login System
         */
        login() {
            if (!this.checkForm()) return;
            this.showModalLoader = true

            firebase.auth().signInWithEmailAndPassword(
                this.$sanitize(this.email),
                this.$sanitize(this.password)
            )
                .then(user => {
                    this.showModalLoader = false
                    this.$store.dispatch('setReAuthenticationFlag', false)
                    this.toastTopEnd('success', this.$t('Re-Authentication'), this.$t('success'))
                    this.$emit("close");
                    this.$parent.reAuthenticationOperation();
                })
                .catch(error => {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.showModalLoader = false
                    this.errors.push(this.$t(errorMessage));   
                });
        },

        facebook_signin(){
            this.showModalLoader = true
            const provider = new firebase.auth.FacebookAuthProvider();

            firebase.auth().signInWithPopup(provider).
                then( (result) => {
                    this.showModalLoader = false
                    this.$store.dispatch('setReAuthenticationFlag', false)
                    this.toastTopEnd('success', this.$t('Re-Authentication'), this.$t('success'))
                    this.$emit("close");
                    this.$parent.reAuthenticationOperation();
                }).catch( (error) => {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.showModalLoader = false
                    this.errors.push(this.$root.$t(errorMessage));
                });
        },

        google_signin(){
            this.showModalLoader = true
            var provider = new firebase.auth.GoogleAuthProvider();

            firebase.auth().signInWithPopup(provider)
                .then( (result) => {
                    this.showModalLoader = false
                    this.$store.dispatch('setReAuthenticationFlag', false)
                    this.toastTopEnd('success', this.$t('Re-Authentication'), this.$t('success'))
                    this.$emit("close");
                    this.$parent.reAuthenticationOperation();
                }).catch((error) => {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    this.showModalLoader = false
                    this.errors.push(this.$root.$t(errorMessage));
                });        
        },

        instantValidator(el, type) {
            if (type === undefined) return;
            if (type === "email") {
                if (!this.email) {
                    this.emailError = this.$t("Email field is empty.");
                } else if (!this.emailValidator(this.email)) {
                    this.emailError = this.$t("Invalid email adrress.");
                } else {
                    this.emailError = "";
                }
            } else if (type === "password") {
                if (!this.password) {
                    this.passError = this.$t("Password field is empty.");
                } else if (!this.passwordValidator(this.password)) {
                    if (this.password.length < 6) {
                        this.passError = this.$t(
                            "Please set a password with more than 6 characters."
                        );
                    } else if (this.password.length > 16) {
                        this.passError = this.$t(
                            "Please set a password with less than 16 characters."
                        );
                    } else if (
                        !/^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9])+$/.test(
                            this.password
                        )
                    ) {
                        this.passError = this.$t(
                            "Password should contain both alphabets and numbers."
                        );
                    } else {
                        this.passError = this.$t("Invalid password format.");
                    }
                } else {
                    this.passError = "";
                }
            }
        },

        checkForm: function(e) {
            this.errors = [];
            if (!this.email) {
                this.errors.push(
                    this.$t("Please input a valid email address.")
                );
            } else if (!this.validEmail(this.email)) {
                this.errors.push(this.$t("Invalid email adrress."));
            }
            if (!this.password)
                this.errors.push(this.$t("Please input a valid password."));
            if (!this.errors.length) return true;
        },

        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        emailValidator: function(email) {
            if (!email) return false;
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        passwordValidator: function(pass) {
            if (!pass) return false;
            var re = /^(?=.*?[a-zA-Z])(?=.*\d)([a-zA-Z0-9]).{5,16}$/; //previous one : /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            return re.test(pass);
        },

    }
};
</script>



// WEBPACK FOOTER //
// src/components/ReAuthenticate.vue